import { UnleashClient, type IMutableContext } from '@unleash/proxy-client-vue';

import { environment, unleashConfig } from '@/config';
import { uiAppName } from '@nova/core';

function customFetch(url: string | URL, init?: RequestInit): Promise<Response> {
  const nextRequestInit: RequestInit = { ...(init ?? {}) };
  const headers = new Headers(nextRequestInit.headers);
  headers.set('X-UI-AppName', uiAppName.COMET);
  nextRequestInit.headers = headers;
  return fetch(url, nextRequestInit);
}

export function getFeatureFlagContext(orgId: string): IMutableContext {
  return { properties: { orgId } };
}

const featureFlagConfig = {
  url: unleashConfig.url,
  appName: unleashConfig.appName,
  fetch: customFetch,
  clientKey: unleashConfig.clientKey,
  disableMetrics: true,
  usePOSTrequests: true,
  environment: environment === 'production' ? 'production' : 'development'
};

let client: UnleashClient | undefined;

export function createFeatureFlagClient(): UnleashClient {
  client ??= new UnleashClient(featureFlagConfig);
  return client;
}

export async function setFeatureFlagOrgId(orgId?: string | null): Promise<void> {
  if (!client || !orgId || client.getContext().properties?.orgId === orgId) {
    return;
  }

  await client.updateContext(getFeatureFlagContext(orgId));
}
